import { useCallback } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import useTranslations from '@/hooks/useTranslations';

export default function PasswordPicker({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
}) {
  const { t } = useTranslations();

  const onRadioButtonChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value === 'true');
    },
    [onChange],
  );

  const options = [
    { label: t('users.sections.passwordPicker.true'), value: true },
    { label: t('users.sections.passwordPicker.false'), value: false },
  ];

  return (
    <RadioGroup name='password-picker-group' value={value} onChange={onRadioButtonChange}>
      {options.map((option, index) => (
        <FormControlLabel
          key={index}
          value={option.value}
          control={<Radio />}
          label={option.label}
        />
      ))}
    </RadioGroup>
  );
}
